import axios from 'axios';
// utils
import { default as appHelper } from 'appCapacitor/helpers/helper.capacitor';

axios.defaults.baseURL = appHelper.getBaseApiUrl();

export const http = axios.create({
  baseURL: appHelper.getBaseApiUrl(),
  timeout: 60000,
});

// Add a response interceptor
http.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    if (error.response.status === 403) {
      console.warn('localStorage.removeItem("token")')
     // localStorage.removeItem("token");
    }

    // Do something with response error
    return Promise.reject(error);
  }
);

export const endpoint = {
  users: {
    single:  (userID) => !!userID && (`users/${userID}`),
    childrenList: (parentID) => !!parentID && (
      `users/${parentID}/children`
    ),
    communications: {
      list: () => (
        `communications/list`
      ),
      single: (commId) => !!commId && (
        `communications/${commId}`
      ),
      markAs: (commId) => !!commId && (
        `communications/marks/${commId}`
      ),
    }
  },
  parent: {
    communications: {
      list: (parentID, childID) => !!parentID && !!childID && (
        `communications/parent/${parentID}/child/${childID}`
      ),
      single: (ID) => !!ID && (
        `communications/response/${ID}`
      ),
      update: (ID, childID) => !!ID && !!childID && (
        `communications/response/${ID}/student/${childID}`
      ),
      new: (parentID, childID) => !!parentID && !!childID && (
        `communications/parent/${parentID}/child/${childID}/new`
      ),
      notRead: (parentID, childID) => !!parentID && !!childID && (
        `communications/parent/${parentID}/child/${childID}/notRead`
      ),
    }
  },
  teacher: {
    communications: {
      list: (userID) => !!userID && (
        `communications/user/${userID}`
      ),
      single: (ID) => !!ID && (
        `communications/response/${ID}`
      ),
      update: (ID, role = 'teacher') => !!ID && !!role && (
        `communications/response/${ID}/role/${role}`
      ),
      notRead: (userID) => !!userID && (
        `communications/teacher/${userID}/notRead`
      ),
    }
  },
}

const api = {
  auth: {
    checkAppVersion: (appVersion, isAppData) =>
      !!appVersion && axios.post(`auth/control/${appVersion}`, { isApp: isAppData }).then(res => res.data),
    forgotPassword: data =>
      !!data && axios.post(`auth/forgot`, data).then(res => res.data),
    resetPassword: data =>
      !!data && axios.post(`auth/reset`, data).then(res => res.data),
    confirmProfile: data =>
      !!data && axios.post(`auth/confirm`, data).then(res => res.data),
    resendConfirmProfile: data =>
      !!data && axios.post(`auth/confirm/resend`, data).then(res => res.data),
    signUp: newUser =>
      !!newUser && axios.post(`auth/signup`, newUser).then(res => res.data),
    registerToken: requestBody =>
      !!requestBody && axios.post(`auth/register`, requestBody).then(res => res.data),
  },
  route: {
    fetchAll: (endpoint, endponitSend) =>
      axios
        .get(endpoint, {
          params: endponitSend,
        })
        .then(res => res.data.data),
    findAll: (endpoint, endponitSend) =>
      axios
        .post(endpoint, {
          params: endponitSend,
        })
        .then(res => res.data),
    fetchById: (endpoint, id) =>
      !!id && axios.get(`${endpoint}/${id}`).then(res => res.data),
    update: (endpoint, objectData) =>
      axios.patch(`${endpoint}/`, objectData).then(res => res.data),
    updateMedia: body =>
      axios.patch(`media/upload/`, body).then(res => res.data),
    remove: (endpoint, objectData) =>
      axios.patch(`${endpoint}/remove`, objectData).then(res => res.data),
  },
  notifications: {
    fetchAllNotifications: (userId, limit, page) =>
      axios
        .get(`notifications/user/${userId}/${limit}/${page}`)
        .then(res => res.data),
    fetchNotificationById: id =>
      axios.get(`notifications/${id}`).then(res => res.data),
    createNotification: (notification, headers) =>
      axios
        .post('notifications/new', notification, { headers: headers })
        .then(res => res.data),
    updateNotification: notification =>
      axios.patch(`notifications/`, notification).then(res => res.data),
    pushNotification: (notification, headers) =>
      axios
        .post(`notifications/push/`, notification, { headers: headers })
        .then(res => res.data),
    deleteNotification: notificationID =>
      axios
        .patch(
          `notifications/delete`,
          {
            objects: [notificationID],
          },
          { headers: headers },
        )
        .then(res => {
          return res.data;
        }),
  },
  absence: {
    updateAbsence: absence =>
      axios.patch(`absence/`, absence).then(res => res.data),
  },
  students: {
    exportStudents: studentsIDs =>
      !!studentsIDs && axios.patch(`students/export`, {
        students: studentsIDs
      }).then(res => res.data),
    validateToken: resetPasswordToken =>
      !!resetPasswordToken && axios.patch(`students/validation`, {
        resetPasswordToken: resetPasswordToken
      }).then(res => res.data),
  },
  users: {
    getByID: id => !!id && axios.get(endpoint.users.single(id)).then(res => res.data),
    getParentChildren: parentID => !!parentID && axios.get(endpoint.users.childrenList(parentID)).then(res => res.data),
    createUser: newUser =>
      !!newUser && axios.post(`users/new`, newUser).then(res => res.data),
    linkStudent: data =>
      !!data && axios.post(`users/linkstudent`, data).then(res => res.data),
   
    update: (data, action = 'update') =>
      !!data && axios.post(`users`, {
        user: data,
        actionType: action
      }).then(res => res.data),
  },
  communications: {
    fetchAllTypes: () =>
      axios.get(`communications/types`).then(res => res.data),
    fetchNotRead: (userId, childId) => {
      if (!!childId) {
        return (
          axios
            .get(endpoint.parent.communications.notRead(userId, childId))
            .then(res => res.data)
        )
      } else {
        return !!userId && (
          axios
            .get(endpoint.teacher.communications.notRead(userId))
            .then(res => res.data)
        )
      }
    },
    remindCommunication: commId =>
      !!commId &&
      axios.post(`communications/remind/${commId}`).then(res => res.data),
    createAudienceFromComm: (commId, audienceObj = { title: 'New Audience' }) =>
      !!commId &&
      axios.post(`audiences/new/${commId}`, audienceObj).then(res => res.data),
    getCommAudiencesById: commId =>
      !!commId &&
      axios
        .get(`communications/audience/${commId}`, null)
        .then(res => res.data),
    updateCommAudiences: (
      commId,
      commObj = {
        deletedIds: {
          students: [],
          users: [],
        },
        addedIds: {
          students: [],
          users: [],
        },
      },
    ) =>
      !!commId &&
      axios
        .post(`communications/audience/${commId}`, commObj)
        .then(res => res.data),
    
    markAs: (commId, type = null) => !!commId &&
      axios.post(endpoint.users.communications.markAs(commId), {
        type
      }).then(res => res.data),
  },
  discussions: {
    getDiscussionById: discussionId =>
      !!discussionId &&
      axios.get(`discussions/${discussionId}`).then(res => res.data),
    markAsRead: discussionId => {
      const local = localStorage.getItem('schoolinked_user');
      const localStd = localStorage.getItem('schoolinked_child');
      const localUser = !!local && JSON.parse(local);
      const localChild = !!localStd && JSON.parse(localStd);
      const body = {
        student: localUser?.role == 'parent' ? localChild?._id : null
      }
      return !!discussionId &&
        axios
          .post(`discussions/readers/${discussionId}`, body)
          .then(res => res.data);
    },
    getDiscussionMessagesById: ({ communicationId, ...rest }) =>
      axios
        .post(`discussions/messages/${communicationId}`, rest)
        .then(res => res.data),
    sendMessage: data => axios.post('messages/new', data).then(res => res.data),
    uploadVoiceMessage: data =>
      axios
        .post(`media/upload-audio`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => res.data),
  },
  media: {
    upload: file => !!file && axios.postForm('media/upload', file).then(res => res.data),
    delete: fileUrl => !!fileUrl && axios.patch('media/delete', {
      url: fileUrl
    }).then(res => res.data),
  }
};

export function setAuthorizationHeader(token) {
  const currentUser = JSON.parse(localStorage.getItem('schoolinked_user'));
  if (!!token || currentUser?.token) {
    const initToken = !!token ? token : currentUser?.token;
    axios.defaults.headers.common.Authorization = `Token ${initToken}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};

export default api;
